/**
 * Helpers for processor-payment method config management.
 * The actual processor→paymentMethod mapping is fetched from S3 at runtime
 * via the /appconfig-api/processor-list endpoint.
 */

export type ProcessorPaymentMethodMap = Record<string, string[]>;

/** Valid weblab values */
export const VALID_WEBLABS = ['W00', 'W01', 'W05', 'W10', 'W25', 'W50', 'W75', 'W100'] as const;

/** Valid amount cap values */
export const VALID_CAPS = ['25', '100', 'NoCAP'] as const;

/** Parse a config value like "W100|NoCAP" into { weblab, amountCap } */
export function parseConfigValue(value: string): { weblab: string; amountCap: string } {
    const parts = value.split('|');
    return {
        weblab: parts[0] || 'W00',
        amountCap: parts[1] || 'NoCAP',
    };
}

/** Combine weblab and amountCap back into "W100|NoCAP" format */
export function formatConfigValue(weblab: string, amountCap: string): string {
    return `${weblab}|${amountCap}`;
}
